namespace Nobox.CRM
{
    @Serenity.Decorators.registerEditor('NoboxCRM.Attr.ProductDealsEditor')
    export class ProductDealsEditor extends Serenity.Extensions.GridEditorBase<ProductdealsRow>{
        protected getColumnsKey() { return ProductdealsColumns.columnsKey; }
        protected getDialogType() { return ProductdealsDialog; }
        protected getLocalTextPrefix() { return ProductdealsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
        validateEntity(row, id) {
            row.PdtId = Q.toId(row.PdtId);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PdtId === row.PdtId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This product is already in order details!');
                return false;
            }

            //row.ProductName = ProductsRow.getLookup().itemById[row.ProductID].Nm;
            row.PdtTotal = (row.PdtQty || 0) * (row.PdtPrc || 0) - (row.PdtDisc || 0);
            return true;
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Remove Attendee',
                name: '',
                format: ctx => '<a class="inline-action delete-deal" title="This product is not permanently deleted before clicking the save & apply changes button.">' +
                    '<i class="fa fa-times text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            //Q.first(columns, x => x.field == fld.CtNm).format =
            //    ctx => `<a href="javascript:;" class="contact-link">${Q.htmlEncode(ctx.value)}</a>`;

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var $this = this;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('delete-deal')) {
                e.preventDefault();

                var items = this.view.getItems();
                items.splice(row, 1);
                this.setItems(items);
            }
        }




    }
}
/*/// <reference path="../." />*/

//namespace Nobox.CRM {

//    import fld = ProductdealsRow.Fields;

//    @Serenity.Decorators.registerEditor('NoboxCRM.Attr.ProductDealsEditor')
//    export class ProductDealsEditor extends  NoboxEntityGrid<ProductdealsRow, any> {
//        protected getColumnsKey() { return ProductdealsColumns.columnsKey; }
//        protected getDialogType() { return ProductdealsDialog; }
//        protected getIdProperty() { return ProductdealsRow.idProperty; }
//        protected getInsertPermission() { return ProductdealsRow.insertPermission; }
//        protected getLocalTextPrefix() { return ProductdealsRow.localTextPrefix; }
//        protected getService() { return ProductdealsService.baseUrl; }

//        constructor(container: JQuery) {
//            super(container);
//        }

//        protected initEntityDialog(itemType, dialog) {
//            super.initEntityDialog(itemType, dialog);
//            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
//        }


//        protected getPersistanceStorage(): Serenity.SettingStorage {
//            return window.localStorage;
//        }

//        //protected getButtons() {
//        //    var buttons = super.getButtons();
//        //    var $this = this;
//        //    buttons[0].onClick = function () {
//        //        var dlg = new LeadDialog();
//        //        dlg.loadEntityAndOpenDialog({ ListId: $this.listId })
//        //    }
//        //    return buttons;
//        //}

//        protected getInitialTitle() {
//            return null;
//        }

//        protected usePager() {
//            return false;
//        }
//        protected getViewOptions() {
//            let opt = super.getViewOptions();
//            //opt.rowsPerPage = 20;
//            //opt.url = "/Services/Nobox/Products/List";
//            return opt;
//        }
//        //protected getPagerOptions() {
//        //    let opt = super.getPagerOptions();
//        //    opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
//        //    return opt;
//        //}
//    }
//}